import React, { Component } from "react";

export default class DetailListBySearchHeader extends Component {
  render() {
    const { error } = this.props;
    let style = error.length > 0 ? { marginBottom: '15px' } : {};
    return <h4 style={style}>{this.props.title}</h4>;
  }
}
